import { FormControl, RadioGroupProps } from '@mui/material';
import { useField } from 'formik';

import { RadioGroup } from '@/components/radioGroup/RadioGroup';
import type { TRadioGroupProps } from '@/components/radioGroup/types';

import type { TOption } from '@/types/common';

// prettier-ignore
type TFormikRadioGroupProps<POption extends TOption<string>> =
  Pick<TRadioGroupProps<POption>, 'variant' | 'options' | 'renderOption'> &
  Omit<RadioGroupProps, 'value' | 'name' | 'onChange'> &
  { name: string }

export const FormikRadioGroup = <POption extends TOption<string>>({
  name,
  ...props
}: TFormikRadioGroupProps<POption>) => {
  const [field, , helpers] = useField<POption['value']>(name);

  return (
    <FormControl>
      <RadioGroup value={field.value} onChange={helpers.setValue} {...props} />
    </FormControl>
  );
};
